import { Component } from '@angular/core';

import { AppService } from './services/app.service';
import { NavigationEnd, Router } from '@angular/router';
import {filter} from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { environment } from 'projects/environments/environment';

declare var gtag;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Auth - Global Service System';
  ParentPath = 'Dashboard';
  constructor(private AppService: AppService, private Router: Router, private TitleService: Title) {
    const navEndEvent =  Router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    );
    navEndEvent.subscribe((event: NavigationEnd) => {
      gtag('config', 'G-HW2M1ETQP0', {
        'page_path': event.urlAfterRedirects
      });
    })
  }

  ngOnInit() {
     this.TitleService.setTitle(environment.Title);
    if (window['config'].Maintenance == true) {
      this.Router.navigate(['/Forbidden']);
    }
  }

  onChangeParentPath(Path: string) {
    this.ParentPath = Path;
  }
}
